import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ServiceHelperService } from "../../service-helper.service";


@Injectable()
export class profileService 
{

    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private _httpClient: HttpClient,private svcHelper: ServiceHelperService,private http: HttpClient,
    ) {}
   

 AddProfile(body) {
    return this._httpClient.post('http://localhost:4000/Profile/addProfile',body);
  }

  getInvestors(){
     
    const url = `${this.svcHelper.getUrl("Profile/getInvestors")}`;
    return this.http.get(url);
  }

  getPieCharValues(){
    const url = `${this.svcHelper.getUrl("Profile/PieChart")}`;
    return this.http.get(url);
  }

  getMonthProfile(){
    const url = `${this.svcHelper.getUrl("Profile/getMonthProfile")}`;
    return this.http.get(url);
  }
}

    